// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JobBatch_accordionHeader__EvB9m {
  background-color: var(--error-color);
  border-bottom: 1px solid var(--tableColor-color);
}

.JobBatch_batchHeader__GBaWP {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.JobBatch_batchTitle__IAMFO {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--heading-color);
}
.JobBatch_clusterTitle__\\+wPEB {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--heading-color);
}

.JobBatch_chipContainer__DsSL9 {
  overflow-x: scroll;
  width: 100%;
  max-width: 700px;
  scrollbar-width: none;
  display: flex;
  gap: 0.5rem;
  /* justify-content: end; */
}
/* 📱 Mobile Phones (≤ 480px) */
@media (max-width: 480px) {
  .JobBatch_chipContainer__DsSL9 {
    max-width: 200px;
  }
}

/* 📱 Small Devices (481px–768px) */
@media (min-width: 481px) and (max-width: 820px) {
  .JobBatch_chipContainer__DsSL9 {
    max-width: 200px;
  }
}

/* 💻 Medium Devices (769px–1024px) like iPads */
@media (min-width: 821px) and (max-width: 1024px) {
  .JobBatch_chipContainer__DsSL9 {
    max-width: 400px;
  }
}

/* 🖥️ Large Screens (1025px–1440px) */
@media (min-width: 1025px) and (max-width: 1440px) {
  .JobBatch_chipContainer__DsSL9 {
    max-width: 500px;
  }
}

/* 🖥️ Extra Large Screens (1441px and up) */
@media (min-width: 1441px) {
  .JobBatch_chipContainer__DsSL9 {
    max-width: 700px;
  }
}

.JobBatch_chipContainer__DsSL9 :first-child {
  margin-left: auto;
}
.JobBatch_chips__vmtNc {
  background-color: var(--dateChip-color) !important;
  font-size: 14px;
  font-weight: 500;
  width: 180px !important;
  color: var(--para-color) !important;
}

.JobBatch_chips__vmtNc span {
  display: flex;
  justify-content: center;
  width: 180px !important;
}
.JobBatch_chip__GHv4\\+ {
  background-color: var(--dateChip-color) !important;
  font-size: 14px;
  font-weight: 500;
  /* width: 200 !important; */
  color: var(--para-color) !important;
}

.JobBatch_ellipsisButton__5LKga {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.JobBatch_accordionDetails__TC0Ko {
  padding: 1rem;
  /* min-height: 200px; */
  height: 60vh;
  /* max-height: 200px; */
  overflow: auto;
}

/* Hide scrollbar but allow scrolling */
.JobBatch_tableContainer__o5nGR {
  margin-top: 1rem;
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  background-color: white;
}

.JobBatch_tableContainer__o5nGR::-webkit-scrollbar {
  display: none;
}

.JobBatch_table__FO8z8 {
  width: 100%;
  border-collapse: collapse;
}

.JobBatch_tableHeader__3ZHMR {
  background-color: var(--secondary-color);
  text-align: left;
  font-size: 16px;
}

.JobBatch_tableCell__OUP5c {
  padding: 16px;
  border-bottom: 1px solid var(--tableColor-color);
  font-size: 20px;
  color: var(--heading-color);
}

.JobBatch_tableHeader__3ZHMR .JobBatch_tableCell__OUP5c {
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
}

.JobBatch_sharedTextStyle__YV0DC {
  font-size: 14px;
  font-weight: bold;
  white-space: nowrap;
  color: var(--para-color);
}

.JobBatch_address2__LvCWw {
  font-size: 14px;
  color: var(--para-color);
  white-space: nowrap;
}

.JobBatch_storeManagerContact__m3OPo {
  font-size: 14px;
  color: var(--para-color);
}

.JobBatch_linkWithImage__4q1iK {
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.JobBatch_link__Xj-T0 {
  margin-left: 0.5rem;
  text-decoration: none;
  color: var(--primary-color);
}

.JobBatch_icon__jV\\+1Q {
  width: 20px;
  height: 20px;
}

/* Added hover effects for better UX */
.JobBatch_link__Xj-T0:hover {
  text-decoration: underline;
  color: var(--primary-color);
}

/* Styling for Pending Status */
.JobBatch_pending__lWWLk {
  background-color: #ffd98e !important;
  color: #c77903 !important;
  font-weight: 400;
  padding: 5px 10px;
  border-radius: 24px;
}
.JobBatch_expired__olU9z {
  background-color: #ffdfdf !important;
  color: #8c0909 !important;
  font-weight: 400;
  padding: 5px 10px;
  border-radius: 24px;
}
.JobBatch_approved__yjSSk {
  color: var(--Golden-color) !important;
  background-color: var(--lightGolden-color) !important;
  font-weight: bold;
  padding: 5px 10px;
  border-radius: 24px;
}
.JobBatch_inProgress__ZsKXe {
  background-color: var(--inProgressBackground-color) !important;
  color: var(--inProgressText-color) !important;
  font-weight: bold;
  padding: 5px 10px;
  border-radius: 24px;
}

/* Styling for PDI Requested */
.JobBatch_pdiRequested__NUaT5 {
  color: var(--Golden-color) !important;
  background-color: var(--lightGolden-color) !important;
  font-weight: bold;
  padding: 5px 10px;
  border-radius: 24px;
}

/* Styling for PDI Approved */
.JobBatch_pdiApproved__laiUZ {
  color: var(--statusChip-color) !important;
  background-color: var(--statusBackground-color) !important;

  font-weight: bold;
  padding: 5px 10px;
  border-radius: 24px;
}

.JobBatch_amountPaid__xoqTv {
  background-color: #ddffd3 !important;
  color: #358c09 !important;

  font-weight: 400;
  padding: 5px 10px;
  border-radius: 24px;
}
.JobBatch_blacklisted__S1S3h {
  background-color: #ffdfdf !important;
  color: #8c0909 !important;
}

.JobBatch_editButton__45Zlx {
  color: var(--primary-color);
}

.JobBatch_noJobsStyle__brygQ {
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (min-width: 768px) {
  .JobBatch_noJobsStyle__brygQ {
    height: 600px;
  }
}
/* next hub media query */
@media (min-width: 1024px) {
  .JobBatch_noJobsStyle__brygQ {
    height: 200px;
  }
}
/* ipad pro media query */
@media (min-width: 1024px) and (min-height: 1200px) {
  .JobBatch_noJobsStyle__brygQ {
    height: 500px;
  }
}

@media (min-width: 1280px) {
  .JobBatch_noJobsStyle__brygQ {
    height: 300px;
  }
}

@media (min-width: 1536px) {
  .JobBatch_noJobsStyle__brygQ {
    height: 400px;
  }
}

.JobBatch_scrollableContainer__IRMfb {
  height: 60vh; /* default for desktop */

  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
}

@media (max-width: 1094px) {
  /* tablets like iPad */
  .JobBatch_scrollableContainer__IRMfb {
    height: 50vh;
  }
}

@media (max-width: 768px) {
  /* small tablets / big phones */
  .JobBatch_scrollableContainer__IRMfb {
    height: 60vh;
  }
}

@media (max-width: 480px) {
  /* phones */
  .JobBatch_scrollableContainer__IRMfb {
    height: 50vh;
  }
}

.JobBatch_scrollable-container__lc0Jx::-webkit-scrollbar {
  display: none;
}
.JobBatch_scrollableBox__9xW0t {
  overflow: auto; /* Or 'scroll' */
  max-height: 300px;
}

/* For Webkit Browsers (Chrome, Safari) */
.JobBatch_scrollableBox__9xW0t::-webkit-scrollbar {
  width: 2px; /* Set scrollbar width */
}

.JobBatch_scrollableBox__9xW0t::-webkit-scrollbar-thumb {
  background-color: var(--para-color); /* Thumb color */
  border-radius: 5px; /* Optional: Rounded edges */
}

.JobBatch_scrollableBox__9xW0t::-webkit-scrollbar-track {
  background: transparent; /* Optional: Background color */
}

.JobBatch_accordionCustom__xe2Da {
  border: 1px solid var(--tableColor-color);
  border-radius: 0.5rem;
  margin-bottom: 10px;
}
.JobBatch_fileName__Dunux {
  margin-left: 2px;
  color: var(--primary-color);
}

.JobBatch_noJobsBox__\\+Na2e {
  text-align: center;
  padding: 2rem;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 8px;
}

.JobBatch_noJobsText__\\+FHrI {
  font-size: 1.2rem;
  color: #888;
}

.JobBatch_searchInput__9IGjo {
  padding: 6px 10px !important;
  font-size: 14px !important;
  border-radius: 6px !important;
  border: 1px solid #ccc !important;
  width: 300px !important;
  max-width: 180px !important;
  outline-color: #1976d2 !important;
  margin-right: 8px !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/AdminportalFolder/jobBatch/JobBatch.module.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,WAAW;EACX,0BAA0B;AAC5B;AACA,+BAA+B;AAC/B;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,gDAAgD;AAChD;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,4CAA4C;AAC5C;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,kDAAkD;EAClD,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,kDAAkD;EAClD,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,sCAAsC;AACtC;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,+BAA+B;AAC/B;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,qCAAqC;EACrC,qDAAqD;EACrD,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,8DAA8D;EAC9D,6CAA6C;EAC7C,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,qCAAqC;EACrC,qDAAqD;EACrD,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,yCAAyC;EACzC,0DAA0D;;EAE1D,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;;EAEzB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;AACF;AACA,yBAAyB;AACzB;EACE;IACE,aAAa;EACf;AACF;AACA,yBAAyB;AACzB;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,YAAY,EAAE,wBAAwB;;EAEtC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB;IACE,YAAY;EACd;AACF;;AAEA;EACE,+BAA+B;EAC/B;IACE,YAAY;EACd;AACF;;AAEA;EACE,WAAW;EACX;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;AACf;AACA;EACE,cAAc,EAAE,gBAAgB;EAChC,iBAAiB;AACnB;;AAEA,yCAAyC;AACzC;EACE,UAAU,EAAE,wBAAwB;AACtC;;AAEA;EACE,mCAAmC,EAAE,gBAAgB;EACrD,kBAAkB,EAAE,4BAA4B;AAClD;;AAEA;EACE,uBAAuB,EAAE,+BAA+B;AAC1D;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,6BAA6B;EAC7B,iCAAiC;EACjC,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,4BAA4B;AAC9B","sourcesContent":[".accordionHeader {\n  background-color: var(--error-color);\n  border-bottom: 1px solid var(--tableColor-color);\n}\n\n.batchHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.batchTitle {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: var(--heading-color);\n}\n.clusterTitle {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--heading-color);\n}\n\n.chipContainer {\n  overflow-x: scroll;\n  width: 100%;\n  max-width: 700px;\n  scrollbar-width: none;\n  display: flex;\n  gap: 0.5rem;\n  /* justify-content: end; */\n}\n/* 📱 Mobile Phones (≤ 480px) */\n@media (max-width: 480px) {\n  .chipContainer {\n    max-width: 200px;\n  }\n}\n\n/* 📱 Small Devices (481px–768px) */\n@media (min-width: 481px) and (max-width: 820px) {\n  .chipContainer {\n    max-width: 200px;\n  }\n}\n\n/* 💻 Medium Devices (769px–1024px) like iPads */\n@media (min-width: 821px) and (max-width: 1024px) {\n  .chipContainer {\n    max-width: 400px;\n  }\n}\n\n/* 🖥️ Large Screens (1025px–1440px) */\n@media (min-width: 1025px) and (max-width: 1440px) {\n  .chipContainer {\n    max-width: 500px;\n  }\n}\n\n/* 🖥️ Extra Large Screens (1441px and up) */\n@media (min-width: 1441px) {\n  .chipContainer {\n    max-width: 700px;\n  }\n}\n\n.chipContainer :first-child {\n  margin-left: auto;\n}\n.chips {\n  background-color: var(--dateChip-color) !important;\n  font-size: 14px;\n  font-weight: 500;\n  width: 180px !important;\n  color: var(--para-color) !important;\n}\n\n.chips span {\n  display: flex;\n  justify-content: center;\n  width: 180px !important;\n}\n.chip {\n  background-color: var(--dateChip-color) !important;\n  font-size: 14px;\n  font-weight: 500;\n  /* width: 200 !important; */\n  color: var(--para-color) !important;\n}\n\n.ellipsisButton {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n}\n\n.accordionDetails {\n  padding: 1rem;\n  /* min-height: 200px; */\n  height: 60vh;\n  /* max-height: 200px; */\n  overflow: auto;\n}\n\n/* Hide scrollbar but allow scrolling */\n.tableContainer {\n  margin-top: 1rem;\n  overflow-x: auto;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  background-color: white;\n}\n\n.tableContainer::-webkit-scrollbar {\n  display: none;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.tableHeader {\n  background-color: var(--secondary-color);\n  text-align: left;\n  font-size: 16px;\n}\n\n.tableCell {\n  padding: 16px;\n  border-bottom: 1px solid var(--tableColor-color);\n  font-size: 20px;\n  color: var(--heading-color);\n}\n\n.tableHeader .tableCell {\n  font-size: 14px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.sharedTextStyle {\n  font-size: 14px;\n  font-weight: bold;\n  white-space: nowrap;\n  color: var(--para-color);\n}\n\n.address2 {\n  font-size: 14px;\n  color: var(--para-color);\n  white-space: nowrap;\n}\n\n.storeManagerContact {\n  font-size: 14px;\n  color: var(--para-color);\n}\n\n.linkWithImage {\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n}\n\n.link {\n  margin-left: 0.5rem;\n  text-decoration: none;\n  color: var(--primary-color);\n}\n\n.icon {\n  width: 20px;\n  height: 20px;\n}\n\n/* Added hover effects for better UX */\n.link:hover {\n  text-decoration: underline;\n  color: var(--primary-color);\n}\n\n/* Styling for Pending Status */\n.pending {\n  background-color: #ffd98e !important;\n  color: #c77903 !important;\n  font-weight: 400;\n  padding: 5px 10px;\n  border-radius: 24px;\n}\n.expired {\n  background-color: #ffdfdf !important;\n  color: #8c0909 !important;\n  font-weight: 400;\n  padding: 5px 10px;\n  border-radius: 24px;\n}\n.approved {\n  color: var(--Golden-color) !important;\n  background-color: var(--lightGolden-color) !important;\n  font-weight: bold;\n  padding: 5px 10px;\n  border-radius: 24px;\n}\n.inProgress {\n  background-color: var(--inProgressBackground-color) !important;\n  color: var(--inProgressText-color) !important;\n  font-weight: bold;\n  padding: 5px 10px;\n  border-radius: 24px;\n}\n\n/* Styling for PDI Requested */\n.pdiRequested {\n  color: var(--Golden-color) !important;\n  background-color: var(--lightGolden-color) !important;\n  font-weight: bold;\n  padding: 5px 10px;\n  border-radius: 24px;\n}\n\n/* Styling for PDI Approved */\n.pdiApproved {\n  color: var(--statusChip-color) !important;\n  background-color: var(--statusBackground-color) !important;\n\n  font-weight: bold;\n  padding: 5px 10px;\n  border-radius: 24px;\n}\n\n.amountPaid {\n  background-color: #ddffd3 !important;\n  color: #358c09 !important;\n\n  font-weight: 400;\n  padding: 5px 10px;\n  border-radius: 24px;\n}\n.blacklisted {\n  background-color: #ffdfdf !important;\n  color: #8c0909 !important;\n}\n\n.editButton {\n  color: var(--primary-color);\n}\n\n.noJobsStyle {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n@media (min-width: 768px) {\n  .noJobsStyle {\n    height: 600px;\n  }\n}\n/* next hub media query */\n@media (min-width: 1024px) {\n  .noJobsStyle {\n    height: 200px;\n  }\n}\n/* ipad pro media query */\n@media (min-width: 1024px) and (min-height: 1200px) {\n  .noJobsStyle {\n    height: 500px;\n  }\n}\n\n@media (min-width: 1280px) {\n  .noJobsStyle {\n    height: 300px;\n  }\n}\n\n@media (min-width: 1536px) {\n  .noJobsStyle {\n    height: 400px;\n  }\n}\n\n.scrollableContainer {\n  height: 60vh; /* default for desktop */\n\n  overflow-y: auto;\n  overflow-x: hidden;\n  scrollbar-width: none;\n}\n\n@media (max-width: 1094px) {\n  /* tablets like iPad */\n  .scrollableContainer {\n    height: 50vh;\n  }\n}\n\n@media (max-width: 768px) {\n  /* small tablets / big phones */\n  .scrollableContainer {\n    height: 60vh;\n  }\n}\n\n@media (max-width: 480px) {\n  /* phones */\n  .scrollableContainer {\n    height: 50vh;\n  }\n}\n\n.scrollable-container::-webkit-scrollbar {\n  display: none;\n}\n.scrollableBox {\n  overflow: auto; /* Or 'scroll' */\n  max-height: 300px;\n}\n\n/* For Webkit Browsers (Chrome, Safari) */\n.scrollableBox::-webkit-scrollbar {\n  width: 2px; /* Set scrollbar width */\n}\n\n.scrollableBox::-webkit-scrollbar-thumb {\n  background-color: var(--para-color); /* Thumb color */\n  border-radius: 5px; /* Optional: Rounded edges */\n}\n\n.scrollableBox::-webkit-scrollbar-track {\n  background: transparent; /* Optional: Background color */\n}\n\n.accordionCustom {\n  border: 1px solid var(--tableColor-color);\n  border-radius: 0.5rem;\n  margin-bottom: 10px;\n}\n.fileName {\n  margin-left: 2px;\n  color: var(--primary-color);\n}\n\n.noJobsBox {\n  text-align: center;\n  padding: 2rem;\n  background-color: #f9f9f9;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n}\n\n.noJobsText {\n  font-size: 1.2rem;\n  color: #888;\n}\n\n.searchInput {\n  padding: 6px 10px !important;\n  font-size: 14px !important;\n  border-radius: 6px !important;\n  border: 1px solid #ccc !important;\n  width: 300px !important;\n  max-width: 180px !important;\n  outline-color: #1976d2 !important;\n  margin-right: 8px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"accordionHeader": `JobBatch_accordionHeader__EvB9m`,
	"batchHeader": `JobBatch_batchHeader__GBaWP`,
	"batchTitle": `JobBatch_batchTitle__IAMFO`,
	"clusterTitle": `JobBatch_clusterTitle__+wPEB`,
	"chipContainer": `JobBatch_chipContainer__DsSL9`,
	"chips": `JobBatch_chips__vmtNc`,
	"chip": `JobBatch_chip__GHv4+`,
	"ellipsisButton": `JobBatch_ellipsisButton__5LKga`,
	"accordionDetails": `JobBatch_accordionDetails__TC0Ko`,
	"tableContainer": `JobBatch_tableContainer__o5nGR`,
	"table": `JobBatch_table__FO8z8`,
	"tableHeader": `JobBatch_tableHeader__3ZHMR`,
	"tableCell": `JobBatch_tableCell__OUP5c`,
	"sharedTextStyle": `JobBatch_sharedTextStyle__YV0DC`,
	"address2": `JobBatch_address2__LvCWw`,
	"storeManagerContact": `JobBatch_storeManagerContact__m3OPo`,
	"linkWithImage": `JobBatch_linkWithImage__4q1iK`,
	"link": `JobBatch_link__Xj-T0`,
	"icon": `JobBatch_icon__jV+1Q`,
	"pending": `JobBatch_pending__lWWLk`,
	"expired": `JobBatch_expired__olU9z`,
	"approved": `JobBatch_approved__yjSSk`,
	"inProgress": `JobBatch_inProgress__ZsKXe`,
	"pdiRequested": `JobBatch_pdiRequested__NUaT5`,
	"pdiApproved": `JobBatch_pdiApproved__laiUZ`,
	"amountPaid": `JobBatch_amountPaid__xoqTv`,
	"blacklisted": `JobBatch_blacklisted__S1S3h`,
	"editButton": `JobBatch_editButton__45Zlx`,
	"noJobsStyle": `JobBatch_noJobsStyle__brygQ`,
	"scrollableContainer": `JobBatch_scrollableContainer__IRMfb`,
	"scrollable-container": `JobBatch_scrollable-container__lc0Jx`,
	"scrollableBox": `JobBatch_scrollableBox__9xW0t`,
	"accordionCustom": `JobBatch_accordionCustom__xe2Da`,
	"fileName": `JobBatch_fileName__Dunux`,
	"noJobsBox": `JobBatch_noJobsBox__+Na2e`,
	"noJobsText": `JobBatch_noJobsText__+FHrI`,
	"searchInput": `JobBatch_searchInput__9IGjo`
};
export default ___CSS_LOADER_EXPORT___;
